import { always, apiFetch } from 'utils'

function queryForGet (page) {
  return { page }
}

export function get (page, filters) {
  return apiFetch(`/search/${window.encodeURIComponent(filters.search)}`, queryForGet(page))
  .catch(always([]))
}



// WEBPACK FOOTER //
// ./resources/assets/js/transport/sitewide.js